import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'lyceo-content',
  imports: [],
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentComponent {
  public background: InputSignal<boolean> = input<boolean>(false);
  public alternate: InputSignal<boolean> = input<boolean>(false);
  public maxWidth: InputSignal<boolean> = input<boolean>(true);
}
